<template>
    <td-dialog
        :title="$t(title)"
        v-dialogDrag
        :before-close="dialogUnRegisterClose"
        :visible.sync="dialogUnRegisterVisible"
        :width="dialogWidth"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        top="18vh"
    >
        <el-row>
            <el-col>
                {{ $t('pgCommon.ANTI_REGISTRATION_SUCCESS') }}
            </el-col>
            <el-col>
                {{ $t('pgCommon.CONFIRM_CODE') + ' : ' }}
                <label v-text="confirmCode"></label>
            </el-col>
        </el-row>
        <div slot="footer" class="btnModuleStyle">
            <td-button @click="dialogUnRegisterClose">{{ $t('pgCommon.CLOSE') }}</td-button>
        </div>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogUnRegisterVisible', 'confirmCode'],
    // 定义变量
    data() {
        return {
            dialogWidth: '300px',
            formLabelWidth: '100px'
        };
    },
    methods: {
        // 关闭窗口之前需要调用的方法
        dialogUnRegisterClose() {
            this.$emit('dialogUnRegisterClose');
        }
    }
};
</script>
<style scope>
.btnModuleStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
